/**
 * Capitalises the first letter of the given string
 */
export function capitaliseFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * Uncapitalises the first letter of the given string
 */
export function uncapitaliseFirstLetter(string: string) {
  return string.charAt(0).toLowerCase() + string.slice(1)
}

/**
 * Converts a string to Capitalize format from UPPER CASE format.
 */
export function toCapitalizedFormat(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

/**
 * Converts a number to the compact format. Ie. 1000 -> 1k
 */
export function nFormatter(num: number, digits: number) {
  const lookup = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'k' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'G' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ]
  let item: { value: number; symbol: string } | undefined

  for (let i = lookup.length - 1; i >= 0; i--) {
    if (num >= lookup[i].value) {
      item = lookup[i]
      break
    }
  }
  if (!item) {
    return '0'
  }
  const formatted = (num / item.value)
    .toFixed(digits)
    .replace(/(\.\d*?[1-9])0+$/, '$1')
    .replace(/\.0+$/, '')
  // oxlint-disable-next-line unicorn/prefer-spread
  return formatted.concat(item.symbol)
}

export function stripHTML(input: string) {
  return input.replace(/<\/?[^>]+(>|$)/g, '')
}
